import AdminOperationsScreen from "../src/features/arrangements/screens/AdminOperationsScreen";

export default function NotificationsScreen() {
  return <AdminOperationsScreen screenIdOverride="notifications" />;
}
